var x = (y) => {
	var x = {}; __webpack_require__.d(x, y); return x
} 
var y = (x) => (() => (x))
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["Fragment"]: () => (__WEBPACK_EXTERNAL_MODULE_https_esm_sh_react_19_0_0_jsx_runtime_628b55ce__.Fragment), ["jsx"]: () => (__WEBPACK_EXTERNAL_MODULE_https_esm_sh_react_19_0_0_jsx_runtime_628b55ce__.jsx), ["jsxs"]: () => (__WEBPACK_EXTERNAL_MODULE_https_esm_sh_react_19_0_0_jsx_runtime_628b55ce__.jsxs) });